import React, { useEffect, useState } from 'react';
import { FlaskConical } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** APR affiliate outbound clicks per article — which guides earn commissions. */
export default function AprClicksCard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/admin/apr-clicks`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem('admin_token') || ''}` },
    })
      .then((r) => r.json())
      .then(setStats)
      .catch(() => {});
  }, []);

  const max = stats?.articles?.[0]?.clicks || 1;

  return (
    <div className="bg-zinc-900 border border-zinc-800 p-6" data-testid="apr-clicks-card">
      <div className="flex items-center justify-between mb-1">
        <h3 className="text-white text-lg font-semibold flex items-center gap-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
          <FlaskConical className="w-4 h-4 text-[#c8ff00]" /> APR Peptide Clicks by Article
        </h3>
        <div className="text-right">
          <span className="text-[#c8ff00] text-xl font-bold" data-testid="apr-clicks-total">{stats?.total ?? 0}</span>
          <span className="text-zinc-500 text-xs ml-2">all time · {stats?.last_30_days ?? 0} last 30d</span>
        </div>
      </div>
      <p className="text-zinc-500 text-xs mb-5">Every outbound americanpeptideresearch.net (ref/16) click, attributed to the article and vial it came from.</p>
      {stats?.articles?.length > 0 ? (
        <div className="space-y-5">
          {stats.articles.map((a, i) => (
            <div key={a.page} data-testid={`apr-article-row-${i}`}>
              <div className="flex items-center justify-between mb-1 gap-3">
                <span className="text-zinc-300 text-sm truncate" title={a.page}>
                  {a.page.replace('/blogs/article/', '') || '/'}
                </span>
                <span className="text-white text-sm font-bold shrink-0">{a.clicks}</span>
              </div>
              <div className="h-2 bg-zinc-800 rounded-full overflow-hidden">
                <div className="h-full bg-[#c8ff00] rounded-full" style={{ width: `${(a.clicks / max) * 100}%` }} />
              </div>
              <p className="text-zinc-600 text-[11px] mt-0.5 truncate">
                top vial: {a.top_product}
                {a.products?.length > 1 && ` · ${a.products.slice(1, 4).map((p) => `${p.product} (${p.clicks})`).join(' · ')}`}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-zinc-600 text-sm" data-testid="apr-clicks-empty">No APR clicks recorded yet — stats appear as soon as readers click a Shop button on a peptide guide.</p>
      )}
      {stats?.top_products?.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-5 pt-4 border-t border-zinc-800" data-testid="apr-top-products">
          {stats.top_products.map((p) => (
            <span key={p.product} className="text-[11px] bg-zinc-800 text-zinc-300 px-2 py-1 rounded-full">
              {p.product} <span className="text-[#c8ff00] font-bold">{p.clicks}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
